/* global */
import './style.less';
import { uniq, orderBy, keyBy, chunk, flatten, intersection } from 'lodash';

export default function($scope, $log, $sce, $stateParams, ApiClass, ProfileClass, $location, store) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id || ProfileClass.profileComplete.profile.profile_uid;

  vm.profile_uid = profile_uid;

  function search(query, dataArray) {
    if (!dataArray || !query) return dataArray;
    return dataArray.filter(obj => {
      for (const key in obj) {
        if (
          !obj.hasOwnProperty(key) ||
          !obj[key] ||
          obj[key]
            .toString()
            .toLowerCase()
            .indexOf(query.toLowerCase()) < 0
        ) {
          continue;
        }
        return true;
      }
    });
  }

  function updateSearch(activities = vm.activities) {
    if (vm.activity_author_filter) {
      activities = activities.filter(({ author }) => author === vm.activity_author_filter);
    }

    if (vm.activity_status_filter) {
      activities = activities.filter(({ status }) => {
        return status === vm.activity_status_filter;
      });
    }

    if (vm.activity_name_filter) {
      activities = search(vm.activity_name_filter, activities);
    }

    if (vm.activity_tags_filter && vm.activity_tags_filter.length) {
      activities = activities.filter(({ tagsSet = [] }) => intersection(tagsSet, vm.activity_tags_filter).length);
    }

    if (vm.activity_tags_filter && vm.activity_tags_filter.length) {
      activities = activities.filter(({ tagsSet = [] }) => intersection(tagsSet, vm.activity_tags_filter).length);
    }

    const order = vm.pagination.sortType.charAt(0) === '+' ? 'asc' : 'desc';
    const sort = vm.pagination.sortType.substr(1);

    vm.pagination.totalItems = activities.length;
    const sortedActivities = orderBy(activities, [sort], [order]);

    if (!vm.pages) {
      vm.pages = [];
    }
    (vm.pages || []).length = 0; // preserves angular binding

    vm.pages.push(...chunk(sortedActivities, vm.pagination.pageSize));
  }

  vm.updateSearch = updateSearch;

  function setView(newView) {
    const currentView = newView || vm.defaultView || $stateParams.view || store.get('activitiesView') || 'table';
    let view = 'table';

    if (currentView === 'card') {
      view = 'card';
    }

    $location.search('view', view);
    store.set('activitiesView', view);
    vm.view = view;
  }

  vm.setView = setView;

  function activate() {
    $log.debug('User Activities Activated');
    vm.loaded = false;
    vm.error = {};

    vm.pagination = {
      pageSize: $stateParams.pageSize || 10,
      page: $stateParams.page || 1,
      showPage: 0,
      sortType: $stateParams.sortType || '+name',
      totalItems: 0,
      setPage: pageNo => {
        vm.pagination.page = pageNo;
        vm.pagination.showPage = pageNo - 1;
      }
    };

    setView();

    ApiClass.activitiesGet(
      { profile_uid, manage: false },
      {},
      { queryParams: { include_progress: true, include_expired: false, 'filter:basic': true } }
    )
      .then(({ data: { items: activities } }) => {
        $log.debug('User Activities Data', activities);

        const statusActivities = activities.map(activity => {
          if (activity.progress) {
            activity.status = activity.progress.completed
              ? 'completed'
              : activity.progress.assigned_by
                ? 'assigned'
                : 'none';
          } else {
            activity.status = 'none';
          }
          return activity;
        });

        vm.activities = statusActivities;
        vm.activitiesDict = keyBy(statusActivities, 'uuid');
        vm.authorGroup = uniq(statusActivities.map(({ author }) => author));
        vm.tagsGroup = uniq(flatten(statusActivities.map(({ tagsSet }) => tagsSet).filter(tagsSet => tagsSet)));

        updateSearch(statusActivities);

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/activities/get/controller.js